import './polyfill';
import './main.scss';

import React from 'react';
import ReactDOM from 'react-dom';
import { RecoilRoot } from 'recoil';

import App from './components/App';
import * as serviceWorker from './serviceWorker';
import { i18nInit } from './i18n';
import { init as initApm } from '@elastic/apm-rum';

i18nInit('svSE');

if (['local', 'dev', 'integration', 'prod'].includes(process.env.REACT_APP_APM_ENVIRONMENT)) {
  initApm({
    serviceName: process.env.REACT_APP_APM_SERVICE_NAME,
    serverUrl: process.env.REACT_APP_APM_SERVER_URL,
    environment: process.env.REACT_APP_APM_ENVIRONMENT,
    disableInstrumentations: ['click']
  });
}

ReactDOM.render(
  <RecoilRoot>
    <App />
  </RecoilRoot>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
